module.exports = __webpack_public_path__ + "static/media/cube.ccfab302.svg";